/* Envoi d'une pièce jointe de messagerie par morceaux (photos, vidéos, documents) → /messages/attachments/*. */
export async function uploadMessageAttachment(api, file, onProgress = () => {}) {
  const raw = api.raw || api;
  const init = await raw.post("/messages/attachments/init", { filename: file.name, content_type: file.type || "application/octet-stream", size: file.size });
  const { attachment_id, chunk_size } = init.data;
  const total = Math.max(1, Math.ceil(file.size / chunk_size));
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * chunk_size, (i + 1) * chunk_size), "part");
    await raw.post(`/messages/attachments/${attachment_id}/chunk`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 });
    onProgress(Math.round(((i + 1) / total) * 95));
  }
  const done = await raw.post(`/messages/attachments/${attachment_id}/complete`);
  onProgress(100);
  return done.data;
}

export const attachmentUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/messages/attachments/${id}`;

export function formatSize(n) {
  if (!n) return "";
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} Ko`;
  return `${(n / (1024 * 1024)).toFixed(1)} Mo`;
}
